import React from 'react';

/* eslint-disable max-len */
const GiftGuideIcon = _ref => {
  let {
    className,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "33",
    height: "33",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76:8113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.57198 7.49169C3.57198 6.9394 4.0197 6.49169 4.57198 6.49169H28.4312C28.9835 6.49169 29.4312 6.9394 29.4312 7.49169V29.3509C29.4312 29.9032 28.9835 30.3509 28.4312 30.3509H4.57198C4.0197 30.3509 3.57198 29.9032 3.57198 29.3509V7.49169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07198 7.99169V28.8509H27.9312V7.99169H5.07198ZM4.57198 6.49169C4.0197 6.49169 3.57198 6.9394 3.57198 7.49169V29.3509C3.57198 29.9032 4.0197 30.3509 4.57198 30.3509H28.4312C28.9835 30.3509 29.4312 29.9032 29.4312 29.3509V7.49169C29.4312 6.9394 28.9835 6.49169 28.4312 6.49169H4.57198Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.643 1.84802C12.5652 1.86956 12.4387 1.93041 12.2688 2.1003C12.1071 2.26197 12.0498 2.38683 12.0294 2.46947C12.0099 2.5486 12.0112 2.64027 12.0549 2.76245C12.1543 3.04047 12.4489 3.40537 12.9811 3.82006C13.5738 4.28194 14.3422 4.71544 15.1111 5.08262C14.7141 4.20989 14.2793 3.36831 13.82 2.73836C13.4328 2.20719 13.11 1.9439 12.8799 1.86256C12.7849 1.82898 12.713 1.82864 12.643 1.84802ZM15.0322 1.85474C15.9164 3.06766 16.6718 4.86033 17.2224 6.208L17.8644 7.77918L16.2705 7.19603C15.0408 6.74616 13.2839 5.95772 12.0591 5.00322C11.4576 4.5345 10.8875 3.95251 10.6425 3.26752C10.514 2.9082 10.4733 2.51434 10.5732 2.10982C10.6722 1.70881 10.8959 1.35192 11.2082 1.03964C11.5122 0.735573 11.856 0.509487 12.2427 0.402413C12.6372 0.293186 13.024 0.322548 13.3798 0.448318C14.0513 0.685672 14.5983 1.25963 15.0322 1.85474Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7382 1.84802C20.816 1.86956 20.9425 1.93041 21.1124 2.1003C21.274 2.26197 21.3314 2.38683 21.3518 2.46947C21.3713 2.5486 21.37 2.64027 21.3263 2.76245C21.2269 3.04047 20.9322 3.40537 20.4001 3.82006C19.8074 4.28194 19.039 4.71544 18.2701 5.08262C18.667 4.20989 19.1019 3.36831 19.5611 2.73836C19.9484 2.20719 20.2712 1.9439 20.5013 1.86256C20.5963 1.82898 20.6682 1.82864 20.7382 1.84802ZM18.349 1.85474C17.4648 3.06766 16.7094 4.86033 16.1588 6.208L15.5168 7.77918L17.1107 7.19603C18.3404 6.74616 20.0973 5.95772 21.3221 5.00322C21.9236 4.5345 22.4937 3.95251 22.7387 3.26752C22.8672 2.9082 22.9079 2.51434 22.808 2.10982C22.709 1.70881 22.4853 1.35192 22.173 1.03964C21.869 0.735573 21.5252 0.509487 21.1385 0.402413C20.744 0.293186 20.3572 0.322548 20.0014 0.448318C19.3299 0.685672 18.7829 1.25963 18.349 1.85474Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58138 7.49169C2.58138 6.9394 3.02909 6.49169 3.58138 6.49169H29.4375C29.9898 6.49169 30.4375 6.9394 30.4375 7.49169V13.7428C30.4375 14.2951 29.9898 14.7428 29.4375 14.7428H3.58138C3.02909 14.7428 2.58138 14.2951 2.58138 13.7428V7.49169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08138 7.99169V13.2428H28.9375V7.99169H4.08138ZM3.58138 6.49169C3.02909 6.49169 2.58138 6.9394 2.58138 7.49169V13.7428C2.58138 14.2951 3.02909 14.7428 3.58138 14.7428H29.4375C29.9898 14.7428 30.4375 14.2951 30.4375 13.7428V7.49169C30.4375 6.9394 29.9898 6.49169 29.4375 6.49169H3.58138Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 6.49169H17.4375V28.9429H15.9375V6.49169Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7189 7.2812C18.7058 6.65952 17.534 6.38413 16.7513 6.31404L16.6175 7.80806C17.2307 7.86298 18.1651 8.08759 18.9343 8.55966C19.6874 9.02183 20.2106 9.6678 20.2475 10.591C20.345 13.0273 20.5378 16.4872 23.4764 18.3507C23.8262 18.5725 24.2896 18.4688 24.5115 18.119C24.7333 17.7692 24.6296 17.3058 24.2797 17.0839C22.0933 15.6974 21.8489 13.0949 21.7463 10.5311C21.6832 8.95431 20.7481 7.91278 19.7189 7.2812Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6561 7.2812C14.6692 6.65952 15.841 6.38413 16.6237 6.31404L16.7575 7.80806C16.1443 7.86298 15.2099 8.08759 14.4407 8.55966C13.6876 9.02183 13.1644 9.6678 13.1275 10.591C13.03 13.0273 12.8372 16.4872 9.89856 18.3507C9.54876 18.5725 9.08535 18.4688 8.86353 18.119C8.6417 17.7692 8.74544 17.3058 9.09525 17.0839C11.2817 15.6974 11.5261 13.0949 11.6287 10.5311C11.6918 8.95431 12.6269 7.91278 13.6561 7.2812Z",
    fill: "#323254"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76:8113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    fill: "white",
    transform: "translate(0.5 0.14291)"
  }))));
};

export { GiftGuideIcon };
